/* ============================================================================
   KADI — Motion (premium/minimal) : UN seul mouvement d'entrée — fade discret
   court (opacity only, 0.35s), via IntersectionObserver. Pas de translate, pas
   de stagger, pas de parallax/pin/count/draw (supprimés — refonte premium).
   Fully no-ops under prefers-reduced-motion (CSS already shows final state).
   ========================================================================== */
(function () {
  'use strict';
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  function ready(fn){ document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn); }

  function revealAll() {
    document.querySelectorAll('[data-reveal], [data-reveal-grid], [data-reveal-lines]')
      .forEach(function (el) { el.classList.add('is-inview'); });
  }
  window.KADI = window.KADI || {};

  ready(function () {
    window.KADI.motionReady = true;
    if (reduce || !('IntersectionObserver' in window)) { revealAll(); return; }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-inview'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });

    document.querySelectorAll('[data-reveal], [data-reveal-grid], [data-reveal-lines]')
      .forEach(function (el) { io.observe(el); });
  });
})();
